/* eslint-disable camelcase */
import { put, call, takeLatest } from "redux-saga/effects";
import { Auth } from "aws-amplify";
import socialLogin from "../../services/amplify.service.auth";
import changePassword from "../../services/amplify.change.password";
import changeEmail from "../../services/amplify.change.email";

import {
  signInSuccess,
  signInFailure,
  signOutSuccess,
  signOutFailure,
  signUpSuccess,
  signUpFailure,
  confirmSuccess,
  confirmFailure,
  signInSocialSuccess,
  signInSocialFailure,
  changePasswordSuccess,
  changePasswordFailure,
  confirmPasswordSuccess,
  confirmPasswordFailure,
  checkEmailSuccess,
  checkEmailFailure,
  changeEmailSuccess,
  changeEmailFailure,
} from "./auth.actions";

import UserActionTypes from "./auth.types";

function* signInStart({ payload: { email, password } }) {
  try {
    const user = yield call([Auth, "signIn"], email, password);

    yield put(signInSuccess(user));

    localStorage.setItem(
      "jwtToken",
      user.signInUserSession.accessToken.jwtToken
    );
    localStorage.setItem("userId", user.attributes.sub);
    localStorage.setItem("userEmail", user.attributes.email);
    localStorage.setItem("userFirstname", user.attributes.given_name);
    localStorage.setItem("userLastname", user.attributes.family_name);
    localStorage.setItem("userPhone", user.attributes.phone_number);
    localStorage.setItem("userPicture", user.attributes.picture);
    localStorage.setItem("userProfile", user.attributes.profile);
    localStorage.setItem("userCompany", user.attributes.website);
    localStorage.setItem("isAuthenticated", true);
  } catch (error) {
    yield put(signInFailure(error));
  }
}

function* signOutStart() {
  try {
    yield call([Auth, "signOut"]);
    yield put(signOutSuccess());
    localStorage.clear();
  } catch (error) {
    yield put(signOutFailure(error));
  }
}

function* signUpStart({
  payload: {
    username,
    password,
    email,
    name,
    family_name,
    given_name,
    phone_number,
    website,
    picture,
    gender,
    profile,
  },
}) {
  try {
    const response = yield call([Auth, "signUp"], {
      username,
      password,
      attributes: {
        email,
        name,
        family_name,
        given_name,
        phone_number,
        website,
        picture,
        gender,
        profile,
      },
    });
    yield put(signUpSuccess(response));
    localStorage.setItem("userId", response.userSub);
    localStorage.setItem("userEmail", email);
    localStorage.setItem("userFirstname", given_name);
    localStorage.setItem("userLastname", family_name);
    localStorage.setItem("userPhone", phone_number);
    localStorage.setItem("userPicture", picture);
    localStorage.setItem("userProfile", profile);
    localStorage.setItem("userCompany", website);
  } catch (error) {
    yield put(signUpFailure(error));
  }
}

function* confirmStart({ payload: { username, code, navigate, link } }) {
  try {
    const response = yield call([Auth, "confirmSignUp"], username, code);
    yield put(confirmSuccess(response));
    navigate(link, { replace: true });
  } catch (error) {
    yield put(confirmFailure(error));
  }
}

function* changePasswordStart({
  payload: { redirectPath, password, newPassword, navigate },
}) {
  try {
    const user = yield call(
      [Auth, "signIn"],
      localStorage.getItem("userEmail"),
      password
    );

    const response = yield changePassword(user, password, newPassword);
    // console.log(response);
    if ("SUCCESS" === response) {
      yield put(changePasswordSuccess(response));
      yield call([Auth, "signOut"]);
      navigate(redirectPath, { replace: true });
    } else {
      yield put(changePasswordFailure(response));
    }
  } catch (error) {
    yield put(changePasswordFailure(error));
  }
}

function* changeEmailStart({
  payload: { redirectPath, password, newEmail, navigate },
}) {
  try {
    const user = yield call(
      [Auth, "signIn"],
      localStorage.getItem("userEmail"),
      password
    );

    const response = yield changeEmail(user, newEmail);
    // console.log(response);
    if ("SUCCESS" === response) {
      yield put(changeEmailSuccess(response));
      yield call([Auth, "signOut"]);
      navigate(redirectPath, { replace: true });
    } else {
      yield put(changeEmailFailure(response));
    }
  } catch (error) {
    yield put(changeEmailFailure(error));
  }
}

function* confirmPasswordStart({
  payload: { redirectPath, username, code, password, navigate },
}) {
  try {
    const response = yield call(
      [Auth, "forgotPasswordSubmit"],
      username,
      code,
      password
    );
    yield put(confirmPasswordSuccess(response));
    navigate(redirectPath, { replace: true });
  } catch (error) {
    yield put(confirmPasswordFailure(error));
  }
}

function* checkEmailStart({ payload: { redirectPath, email, navigate } }) {
  try {
    const response = yield call([Auth, "forgotPassword"], email);
    yield put(checkEmailSuccess(response));
    navigate(redirectPath, { replace: true });
  } catch (error) {
    yield put(checkEmailFailure(error));
  }
}

function* signInSocialStart({ payload }) {
  const { provider } = payload;
  try {
    const result = yield socialLogin(provider);
    yield put(signInSocialSuccess(result.user));
  } catch (error) {
    yield put(signInSocialFailure(error));
  }
}

export default function* authSagas() {
  yield takeLatest(UserActionTypes.SIGN_IN_START, signInStart);
  yield takeLatest(UserActionTypes.SIGN_OUT_START, signOutStart);
  yield takeLatest(UserActionTypes.SIGN_UP_START, signUpStart);
  yield takeLatest(UserActionTypes.COMFIRM_START, confirmStart);

  yield takeLatest(UserActionTypes.CHANGE_EMAIL_START, changeEmailStart);
  yield takeLatest(UserActionTypes.CHECK_EMAIL_START, checkEmailStart);
  yield takeLatest(
    UserActionTypes.CONFIRM_PASSWORD_START,
    confirmPasswordStart
  );
  yield takeLatest(UserActionTypes.CHANGE_PASSWORD_START, changePasswordStart);
  yield takeLatest(UserActionTypes.SIGN_IN_SOCIAL_START, signInSocialStart);
}
